import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ReactQueryKey } from "../../../../../../../types";

import { getBookingSegments } from "../../../../../../../api/services";

import { FormAutocomplete } from "../../../../../../../components/fields";
import useFormTenantsDealers from "../form-tenants-dealers-hook/useFormTenantsDealers";

/**
 * Filter Form component of segments
 */
const FormAutocompleteSegment = () => {
    const { t } = useTranslation('booking');
    const { tenants, dealers } = useFormTenantsDealers();

    const segmentsQuery = useQuery({
        queryKey: [ReactQueryKey.BookingSegments, { tenants, dealers }],
        queryFn: () => getBookingSegments({ tenants, dealers }),
    });

    return (
        <FormAutocomplete<any>
            name="segments"
            label={t('label.segments')}
            options={segmentsQuery.data || []}
            loading={segmentsQuery.isLoading}
            isOptionEqualToValue={(option: any, value: any) => option.code === value.code}
            multiple
        />
    );

}

export default FormAutocompleteSegment;
